import { useState, Dispatch, SetStateAction, useEffect } from "react";
import { Modal, Tabs } from "@weirgroup/weir-dls";
import { BucketDataType, GroupedReplacementPartType, ReplacementPartType, TagType } from "../../types/bucketTypes";
import { GeofenceTab } from "./components/geofence-tab";
import { ReplacementParts } from "./components/replacement-parts-tab";
import { Documents } from "./components/documents-tab";
import Transfer from "./components/transfer-tab";
import { LocationsTab } from "./components/locations-tab";
import { AddNonEsco } from "./components/add-non-esco";

import "./styles.scss";
import assetsApi from "../../api/assets.api";
import { getImgSrc } from "../../helpers/getImageSrc";
import { AssetDocumentType } from "../../types/documents.type";
import { AddBillOfMaterial } from "./components/add-bill-of-material";
import { useDarkMode } from "../../hooks/use-darkmode";
import { LoadingSpinner } from "../loading-spinner";

interface Props {
  isModalShown: boolean
  setIsModalShown: (arg: boolean) => void
  selectedAsset: BucketDataType
  setSelectedAsset: Dispatch<SetStateAction<any>>
  tagData: TagType
  fetchBucketList: () => Promise<void>
  replacementParts: GroupedReplacementPartType
  isGuest: boolean
  isFetchingGeofences: boolean
  setIsFetchingGeofences: Dispatch<SetStateAction<boolean>>
  triggerToastMessage: (arg1: boolean, arg2: any) => void
}

export const PopupModal = (props: Props) => {
  const {
    isModalShown,
    setIsModalShown,
    selectedAsset,
    tagData,
    setSelectedAsset,
    fetchBucketList,
    replacementParts,
    isGuest,
    isFetchingGeofences,
    setIsFetchingGeofences,
    triggerToastMessage
  } = props;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddNonEscoPart, setShowAddNonEscoPart] = useState<boolean>(false);
  const [showAddBillOfMaterial, setShowAddBillOfMaterial] = useState<boolean>(false);
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
  const [editPart, setEditPart] = useState<ReplacementPartType>();
  const [editBill, setEditBill] = useState<ReplacementPartType>();
  const [geofenceList, setGeofenceList] = useState<any>([]);
  const [assetDocs, setAssetDocs] = useState<AssetDocumentType[]>([])
  const [isAssetUpdated, setIsAssetUpdated] = useState<boolean>(false)
  const {darkMode} = useDarkMode();
  const getSingleAssets = async (assetId: any) => {
    if (assetId === undefined || assetId === null || assetId === "" || isNaN(Number(assetId))) {
      // Invalid assetId, do not call API
      return false;
    }
    try {
      const asset = await assetsApi.getSingleAsset(assetId);
      return asset;
    } catch (e) {
      console.error("Failed to fetch asset:", e);
      return false;
    }
  }
  const getGeofences = () => {
    try {
      const sessionAssetData = sessionStorage.getItem('selectedAsset');
      let assetId;
      if (sessionAssetData) {
        assetId = JSON.parse(sessionAssetData).asset_id
      }
      if (assetId === undefined || assetId === null) {
        console.warn('getGeofences: assetId is undefined or null, aborting API call.');
        return;
      }
      setIsFetchingGeofences(true)
      getSingleAssets(assetId).then((asset:any)=>{
        if(asset){
          setIsFetchingGeofences(false)
          setGeofenceList(asset.data.data.geofences)
          setAssetDocs(asset.data.data.documents)
        }else{
          setIsFetchingGeofences(false)
        }
      })
      if (assetId !== undefined) {
        assetsApi.getSingleAsset(assetId).then((asset: any) => {
          setIsFetchingGeofences(false)
          setGeofenceList(asset.data.data.geofences)
          setAssetDocs(asset.data.data.documents)
        }).catch(() => {
          setIsFetchingGeofences(false)
        })
      }
    } catch (error) {
      console.error(error)
    }
    
  }
  useEffect(() => {
    setEditPart(undefined)
    setEditBill(undefined)
    if (tagData) {
      getGeofences();
    }
  }, [tagData])

  useEffect(() => {
    if (geofenceList.length > 0) {
      let sortedList = geofenceList.sort((item1: any, item2: any) => {
        let date1: any = new Date(item1.updated_at);
        let date2: any = new Date(item2.updated_at);
        return date2 - date1;
      }
      );
      setGeofenceList(sortedList)
    }
  }, [geofenceList])

  const toggleBillOfMaterialForm = (isEdit?: boolean, partData?: any) => {
    if (isEdit) {
      setEditBill(partData);
      setShowAddBillOfMaterial(true);
    } else {
      setShowAddBillOfMaterial(true);
    }
  }

  const tabItems = [
    // {
    //   title: "ASSET OVERVIEW",
    //   component: <div className="tab-item-container"><AssetOverview
    //   assetStatus={assetStatus}
    //   selectedAsset={selectedAsset}
    //   setSelectedAsset={setSelectedAsset}
    //   tagData={tagData}
    //   isLoading={isLoading}
    //   setIsLoading={setIsLoading}
    //   setIsAssetUpdated={setIsAssetUpdated}
    //   isGuest={isGuest}
    // /></div>,
    // },
    {
      title: "REPLACEMENT PARTS",
      component: 
        <div className="tab-item-container">
          <ReplacementParts
            selectedAsset={selectedAsset}
            setShowBillOfMaterial={setShowAddBillOfMaterial}
            groupedReplacementParts={replacementParts}
            toggleBillOfMaterial={toggleBillOfMaterialForm}
            setEditBill={setEditBill}
            isGuest={isGuest}
          />
      </div>,
    },
    {
      title: "DOCUMENTS",
      component: 
      <div className="tab-item-container">
        <Documents documents={assetDocs} refreshList={()=> getGeofences()} isLoadingFetch={isLoading}  />
      </div>,
    },
    {
      title: "GEOFENCE",
      component: 
      <div className="tab-item-container">
        <GeofenceTab
          tagData={tagData}
          geofenceData={geofenceList}
          refreshList={() => getGeofences()}
          setIsAssetUpdated={setIsAssetUpdated}
          isGuest={isGuest}
        />
      </div>,
    },
    {
      title: "TRANSFER",
      component: 
      <div className="tab-item-container">
        <Transfer 
          isGuest={isGuest} 
          setIsModalShown={setIsModalShown}
          fetchBucketList={fetchBucketList}
          selectedAsset={selectedAsset}
          triggerToastMessage={triggerToastMessage}
        />
      </div>
    },
    {
      title: "LOCATIONS",
      component: 
      <div className="tab-item-container">
        <LocationsTab tagData={tagData} />
      </div>
    }
  ];

  const onModalClose = async () => {
    setIsLoading(true)
    if (isAssetUpdated) {
      await fetchBucketList();
      setIsLoading(false);
    }
    setIsModalShown(false);
  }
let billOfMaterial = 
showAddBillOfMaterial ? <AddBillOfMaterial 
setShowAddNonEscoPart={setShowAddBillOfMaterial}
setActiveTabIndex={setActiveTabIndex}
selectedAsset={selectedAsset}
setSelectedAsset={setSelectedAsset}
editPart={editBill}
fetchBucketList={fetchBucketList}/>
:
<>
<div className="modal-title-style">
<p className="modal-title" style={{color:darkMode ? "white" : "black"}}><img style={{color:darkMode ? "white" : "black"}} src={getImgSrc(tagData, false)} alt="AssetIcon" /></p>
<p className="modal-title" style={{color:darkMode ? "white" : "black"}}>
 
  {selectedAsset.serial_number}
</p>
</div>

<Tabs
  darkMode={darkMode}
  items={tabItems}
  disabled={isLoading ?? isFetchingGeofences}
  activeTabIndex={activeTabIndex}
  canvasDeviceSize="desktop"
/>
</>
  return (
    <div className={isLoading || isFetchingGeofences ? "disable-pointer" : ""} data-testid="modal">
      <Modal
        darkMode={darkMode}
        showModal={isModalShown}
        onClose={() => onModalClose()}
        size="small"
        canvasDeviceSize="desktop"
        dismissable={true}
        applyModalInternalGrid={true}
        modalType={"small"}

      >
        <div className={isLoading || isFetchingGeofences ? "disable-pointer modal-container" : "modal-container"}>
          {isFetchingGeofences ? <LoadingSpinner darkMode={darkMode} /> : <></>}
          {showAddNonEscoPart ?
            <AddNonEsco
              setShowAddNonEscoPart={setShowAddNonEscoPart}
              setActiveTabIndex={setActiveTabIndex}
              selectedAsset={selectedAsset}
              setSelectedAsset={setSelectedAsset}
              editPart={editPart}
              fetchBucketList={fetchBucketList}
            />
            :billOfMaterial
          }
        </div>
      </Modal>
    </div>
  );
};